export const translations = {
  en: {
    faqTitle: 'Frequently Asked Questions',
    faqQuestions: [
      {
        question: 'What is included in my ticket?',
        answer:
          'Each ticket tier includes different benefits. All tiers include admission to the immersive experience and a multi-course dinner inspired by Punjabi royal cuisine. Higher tiers include additional benefits such as commemorative items, behind-the-scenes access, and recognition opportunities.',
      },
      {
        question: 'Is there a dress code?',
        answer:
          'We encourage formal attire or traditional Punjabi/Sikh dress. The event is a celebration of culture and heritage, and many guests choose to wear their finest traditional clothing.',
      },
      {
        question: 'Are dietary restrictions accommodated?',
        answer:
          "Yes, we accommodate vegetarian, vegan, gluten-free, and other dietary restrictions. You'll be able to indicate your preferences when finalizing your reservation.",
      },
      {
        question: 'Is the venue accessible?',
        answer:
          'Yes, the Illuminarium Toronto is fully accessible for guests with mobility requirements. Please contact us in advance if you have specific accessibility needs.',
      },
      {
        question: 'Are tax receipts available?',
        answer:
          'Yes, a portion of each ticket purchase is tax-deductible as a charitable donation. Tax receipts will be provided for the donation portion of your purchase.',
      },
    ],
    footerTitle: 'Life in the Sikh Kingdoms',
    footerDescription:
      "An immersive journey through one of history's most fascinating empires. Experience the culture, art, and legacy of the Sikh Kingdoms like never before.",
    quickLinks: 'Quick Links',
    links: [
      { text: 'Home', href: '#hero' },
      { text: 'About', href: '#about' },
      { text: 'Experience', href: '#immersive-experience' },
      { text: 'Creators', href: '#creators' },
      { text: 'Tickets', href: '#tickets' },
      { text: 'Sitemap', href: '/sitemap.xml' },
    ],
    contactUs: 'Contact Us',
    subscribe: 'Subscribe for Updates',
    copyright: '© 2026 Life in the Sikh Kingdoms',
    allRightsReserved: 'All Rights Reserved',
  },
  pa: {
    faqTitle: 'ਅਕਸਰ ਪੁੱਛੇ ਜਾਣ ਵਾਲੇ ਸਵਾਲ',
    faqQuestions: [
      {
        question: 'ਮੇਰੀ ਟਿਕਟ ਵਿੱਚ ਕੀ ਸ਼ਾਮਲ ਹੈ?',
        answer:
          'ਹਰ ਟਿਕਟ ਟੀਅਰ ਵਿੱਚ ਵੱਖ-ਵੱਖ ਲਾਭ ਸ਼ਾਮਲ ਹਨ। ਸਾਰੇ ਟੀਅਰਾਂ ਵਿੱਚ ਇਮਰਸਿਵ ਅਨੁਭਵ ਲਈ ਦਾਖਲਾ ਅਤੇ ਪੰਜਾਬੀ ਸ਼ਾਹੀ ਪਕਵਾਨਾਂ ਤੋਂ ਪ੍ਰੇਰਿਤ ਮਲਟੀ-ਕੋਰਸ ਡਿਨਰ ਸ਼ਾਮਲ ਹੈ। ਉੱਚ ਟੀਅਰਾਂ ਵਿੱਚ ਯਾਦਗਾਰੀ ਆਈਟਮਾਂ, ਪਰਦੇ ਦੇ ਪਿੱਛੇ ਦੀ ਪਹੁੰਚ, ਅਤੇ ਮਾਨਤਾ ਦੇ ਮੌਕੇ ਵਰਗੇ ਵਾਧੂ ਲਾਭ ਸ਼ਾਮਲ ਹਨ।',
      },
      {
        question: 'ਕੀ ਕੋਈ ਡਰੈੱਸ ਕੋਡ ਹੈ?',
        answer:
          'ਅਸੀਂ ਰਸਮੀ ਪਹਿਰਾਵੇ ਜਾਂ ਪਰੰਪਰਾਗਤ ਪੰਜਾਬੀ/ਸਿੱਖ ਪਹਿਰਾਵੇ ਨੂੰ ਉਤਸ਼ਾਹਿਤ ਕਰਦੇ ਹਾਂ। ਇਹ ਸਮਾਗਮ ਸੱਭਿਆਚਾਰ ਅਤੇ ਵਿਰਾਸਤ ਦਾ ਜਸ਼ਨ ਹੈ, ਅਤੇ ਬਹੁਤ ਸਾਰੇ ਮਹਿਮਾਨ ਆਪਣੇ ਵਧੀਆ ਪਰੰਪਰਾਗਤ ਕੱਪੜੇ ਪਹਿਨਣਾ ਪਸੰਦ ਕਰਦੇ ਹਨ।',
      },
      {
        question: 'ਕੀ ਖਾਣ-ਪੀਣ ਦੀਆਂ ਪਾਬੰਦੀਆਂ ਦਾ ਧਿਆਨ ਰੱਖਿਆ ਜਾਂਦਾ ਹੈ?',
        answer:
          'ਹਾਂ, ਅਸੀਂ ਸ਼ਾਕਾਹਾਰੀ, ਵੈਗਨ, ਗਲੂਟਨ-ਮੁਕਤ, ਅਤੇ ਹੋਰ ਖੁਰਾਕ ਸੰਬੰਧੀ ਪਾਬੰਦੀਆਂ ਨੂੰ ਧਿਆਨ ਵਿੱਚ ਰੱਖਦੇ ਹਾਂ। ਤੁਸੀਂ ਆਪਣੀ ਰਿਜ਼ਰਵੇਸ਼ਨ ਨੂੰ ਅੰਤਮ ਰੂਪ ਦੇਣ ਵੇਲੇ ਆਪਣੀਆਂ ਤਰਜੀਹਾਂ ਦਾ ਸੰਕੇਤ ਦੇ ਸਕੋਗੇ।',
      },
      {
        question: 'ਕੀ ਵੇਨਿਊ ਪਹੁੰਚਯੋਗ ਹੈ?',
        answer:
          'ਹਾਂ, ਇਲੂਮੀਨੇਰੀਅਮ ਟੋਰਾਂਟੋ ਮੋਬਿਲਿਟੀ ਲੋੜਾਂ ਵਾਲੇ ਮਹਿਮਾਨਾਂ ਲਈ ਪੂਰੀ ਤਰ੍ਹਾਂ ਪਹੁੰਚਯੋਗ ਹੈ। ਜੇ ਤੁਹਾਡੀਆਂ ਕੋਈ ਵਿਸ਼ੇਸ਼ ਪਹੁੰਚਯੋਗਤਾ ਲੋੜਾਂ ਹਨ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ ਪਹਿਲਾਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।',
      },
      {
        question: 'ਕੀ ਟੈਕਸ ਰਸੀਦਾਂ ਉਪਲਬਧ ਹਨ?',
        answer:
          "ਹਾਂ, ਹਰ ਟਿਕਟ ਖਰੀਦ ਦਾ ਇੱਕ ਹਿੱਸਾ ਦਾਨ ਦੇ ਤੌਰ 'ਤੇ ਟੈਕਸ-ਕਟੌਤੀਯੋਗ ਹੈ। ਤੁਹਾਡੀ ਖਰੀਦ ਦੇ ਦਾਨ ਵਾਲੇ ਹਿੱਸੇ ਲਈ ਟੈਕਸ ਰਸੀਦਾਂ ਪ੍ਰਦਾਨ ਕੀਤੀਆਂ ਜਾਣਗੀਆਂ।",
      },
    ],
    footerTitle: 'ਸਿੱਖ ਰਾਜਾਂ ਵਿੱਚ ਜੀਵਨ',
    footerDescription:
      'ਇਤਿਹਾਸ ਦੇ ਸਭ ਤੋਂ ਦਿਲਚਸਪ ਸਾਮਰਾਜਾਂ ਵਿੱਚੋਂ ਇੱਕ ਦੀ ਇੱਕ ਇਮਰਸਿਵ ਯਾਤਰਾ। ਸਿੱਖ ਰਾਜਾਂ ਦੇ ਸੱਭਿਆਚਾਰ, ਕਲਾ ਅਤੇ ਵਿਰਾਸਤ ਦਾ ਪਹਿਲਾਂ ਕਦੇ ਨਾ ਕੀਤੇ ਗਏ ਤਰੀਕੇ ਨਾਲ ਅਨੁਭਵ ਕਰੋ।',
    quickLinks: 'ਤੇਜ਼ ਲਿੰਕ',
    links: [
      { text: 'ਹੋਮ', href: '#hero' },
      { text: 'ਬਾਰੇ', href: '#about' },
      { text: 'ਅਨੁਭਵ', href: '#immersive-experience' },
      { text: 'ਰਚਨਾਕਾਰ', href: '#creators' },
      { text: 'ਟਿਕਟਾਂ', href: '#tickets' },
      { text: 'ਸਾਈਟਮੈਪ', href: '/sitemap.xml' },
    ],
    contactUs: 'ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ',
    subscribe: 'ਅਪਡੇਟਾਂ ਲਈ ਸਬਸਕ੍ਰਾਈਬ ਕਰੋ',
    copyright: '© 2026 ਸਿੱਖ ਰਾਜਾਂ ਵਿੱਚ ਜੀਵਨ',
    allRightsReserved: 'ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ',
  },
  fr: {
    faqTitle: 'Questions Fréquemment Posées',
    faqQuestions: [
      {
        question: "Qu'est-ce qui est inclus dans mon billet?",
        answer:
          "Chaque niveau de billet comprend différents avantages. Tous les niveaux comprennent l'admission à l'expérience immersive et un dîner à plusieurs plats inspiré de la cuisine royale punjabi. Les niveaux supérieurs comprennent des avantages supplémentaires tels que des articles commémoratifs, un accès aux coulisses et des opportunités de reconnaissance.",
      },
      {
        question: 'Y a-t-il un code vestimentaire?',
        answer:
          "Nous encourageons la tenue de soirée ou les vêtements traditionnels punjabi/sikh. L'événement est une célébration de la culture et du patrimoine, et de nombreux invités choisissent de porter leurs plus beaux vêtements traditionnels.",
      },
      {
        question: 'Les restrictions alimentaires sont-elles prises en compte?',
        answer:
          "Oui, nous tenons compte des régimes végétariens, végétaliens, sans gluten et d'autres restrictions alimentaires. Vous pourrez indiquer vos préférences lors de la finalisation de votre réservation.",
      },
      {
        question: 'Le lieu est-il accessible?',
        answer:
          "Oui, l'Illuminarium Toronto est entièrement accessible aux personnes à mobilité réduite. Veuillez nous contacter à l'avance si vous avez des besoins d'accessibilité spécifiques.",
      },
      {
        question: 'Des reçus fiscaux sont-ils disponibles?',
        answer:
          "Oui, une partie de chaque achat de billet est déductible d'impôt en tant que don caritatif. Des reçus fiscaux seront fournis pour la partie don de votre achat.",
      },
    ],
    footerTitle: 'La Vie dans les Royaumes Sikhs',
    footerDescription:
      "Un voyage immersif à travers l'un des empires les plus fascinants de l'histoire. Découvrez la culture, l'art et l'héritage des Royaumes Sikhs comme jamais auparavant.",
    quickLinks: 'Liens Rapides',
    links: [
      { text: 'Accueil', href: '#hero' },
      { text: 'À Propos', href: '#about' },
      { text: 'Expérience', href: '#immersive-experience' },
      { text: 'Créateurs', href: '#creators' },
      { text: 'Billets', href: '#tickets' },
      { text: 'Plan du Site', href: '/sitemap.xml' },
    ],
    contactUs: 'Contactez-Nous',
    subscribe: "S'abonner aux Mises à Jour",
    copyright: '© 2026 La Vie dans les Royaumes Sikhs',
    allRightsReserved: 'Tous Droits Réservés',
  },
}
